import { gql } from "@apollo/client";

export const activateTierRules = gql`
  mutation ActivateTierRules($tierRulesId: ID!) {
    activateTierRules(tierRulesId: $tierRulesId) {
      operationId
      operationType
      phase
      outcome
      historicalQualificationMode
      configVersion
      calculationVersion
      totalCount
      processedCount
      succeededCount
      failedCount
      restoredCount
      pendingCount
      checkpointUpdatedAt
      deferredTriggerCount
      deferredTriggerHighWater
      requestedAt
      updatedAt
      completedAt
      errorCode
      errorSummary
    }
  }
`;

export const deactivateTierRules = gql`
  mutation DeactivateTierRules($tierRulesId: ID!) {
    deactivateTierRules(tierRulesId: $tierRulesId) {
      operationId
      operationType
      phase
      outcome
      historicalQualificationMode
      configVersion
      calculationVersion
      totalCount
      processedCount
      succeededCount
      failedCount
      restoredCount
      pendingCount
      checkpointUpdatedAt
      deferredTriggerCount
      deferredTriggerHighWater
      requestedAt
      updatedAt
      completedAt
      errorCode
      errorSummary
    }
  }
`;
